module.exports = __webpack_public_path__ + "static/media/muzei-photos-ss.75d8bb84.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/muzei-photos-ss.png
 ** module id = 207
 ** module chunks = 0
 **/